namespace TabAurous.Production {
    export interface JobWorkIssueBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        BomProductId?: number;
        CalcOnId?: number;
        AttributeId?: number;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        FromDeptId?: number;
        ToDeptId?: number;
        FromWorkerId?: number;
        ToWorkerId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefTransBomId?: number;
        IsCustomerItem?: boolean;
        Markup?: number;
        Lab?: string;
        CertificateNo?: string;
        SettingId?: number;
        StoneStatusId?: number;
        ProductCode?: string;
        ProductName?: string;
        ItemType?: string;
        CalcOn?: string;
        HasBom?: boolean;
        ItemTypeId?: number;
        ProductTypeId?: number;
        SubCategoryId?: number;
        CategoryId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        SettingName?: string;
        StoneStatusName?: string;
    }

    export namespace JobWorkIssueBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.JobWorkIssueBOM';
        export const deletePermission = 'Production:JobWorkIssue:Delete';
        export const insertPermission = 'Production:JobWorkIssue:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:JobWorkIssue:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            FromDeptId = "FromDeptId",
            ToDeptId = "ToDeptId",
            FromWorkerId = "FromWorkerId",
            ToWorkerId = "ToWorkerId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefTransBomId = "RefTransBomId",
            IsCustomerItem = "IsCustomerItem",
            Markup = "Markup",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            SettingId = "SettingId",
            StoneStatusId = "StoneStatusId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            ItemType = "ItemType",
            CalcOn = "CalcOn",
            HasBom = "HasBom",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            SubCategoryId = "SubCategoryId",
            CategoryId = "CategoryId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            SettingName = "SettingName",
            StoneStatusName = "StoneStatusName"
        }
    }
}
